import { Component, OnInit, ViewChild, Input, ChangeDetectionStrategy } from '@angular/core';
import { DataService } from '../../services/DataService';
import { UntypedFormBuilder, UntypedFormGroup,Validators } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AppComponent } from 'src/app/app.component';
import { JobProfileLandingComponent } from '../job-profile-landing/job-profile-landing.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { JobProfile } from 'src/app/models/jobprofile';
import { MatSelectChange } from '@angular/material/select';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';


@Component({
    selector: 'app-job-profile-matching',
    templateUrl: './job-profile-matching.component.html',
    styleUrls: ['./job-profile-matching.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class JobProfileMatchingComponent implements OnInit {
  @Input() jobProfilePage: string;
  dbselected: boolean = false;
  imageUrl: string = '../../../assets/images/Job-profile-main.jpg';
  public isCollapsed = false;
  form: UntypedFormGroup;
  private storage: any;
  //public ELEMENT_DATA:{}[];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
 // dropdownSettings: IDropdownSettings = {};
  displayedColumns:string[]=[];
  ShowLoader :string = "none";
  jobTitle:string='';
  jobDescription:string='';
  errorMsg:string='';
  todaydate:string;
  loadmsg=true;
  // filterValues:any = {};
  // filterSelectObj:any = [];
  file:File;
  filters:any=[];
  fileLimitexceeded:boolean=false;
  showResults:boolean=false;
  filterDictionary = new Map<string, string>();
  ELEMENT_DATA:JobProfile[]=[];
  showRefreshbtn=false;
  mainresult:any;
  aqchecked:boolean
  headertext:string
  check_jobtitle:boolean
  check_jobdesc:boolean
  jobfamilygroup:any[]=[]
  dropdownList = [];
  downloadhref="assets/Templates/jobprofilematching.xlsx"

  //selectedItems=[];
  checkedarray: string[] = []
  selectedItems: any[] = [];
  insobj=''
insertarray:string[] = []
allSelected=false;
firsttimechecked = false;
  dropdownSettings:IDropdownSettings={idField:'Filter',textField:'Filter', allowSearchFilter: true, "defaultOpen": false,itemsShowLimit:3};
  dropDownForm:UntypedFormGroup;
  
  seljobfamilygroup =""
  pageload=false;
  submitclicked=false;
  
//   uniqueJobFamilyList:{item_id:number,item_text:string}[]=[];
//   selectedJobTitle:string[]=[];
//   componentList=[{'component':'app-job-profile-matching','title':'Job Profile Matching','description':'Machine Learning and AI enabled algorithm to generate match score corresponding to job descriptions under radar','imageSrc':'../../../assets/images/textanalysis.png'},
//   {'component':'app-speech-tagging','title':'Part of Speech tagging','description':'Option to generate part of speech tagging that will enable user in quickly understanding the various part of speech components that exists in long data which in turn helps in quick decision making','imageSrc':'../../../assets/images/textanalysis.png'},
//   {'component':'app-name-entity-recognition','title':'Name Entity Recognition','description':'Option to generate part of speech tagging that will enable user in quickly understanding the various part of speech components that exists in long data which in turn helps in quick decision making','imageSrc':'../../../assets/images/textanalysis.png'},
//   {'component':'app-text-summarizer','title':'Text Summarizer','description':'Option to generate part of speech tagging that will enable user in quickly understanding the various part of speech components that exists in long data which in turn helps in quick decision making','imageSrc':'../../../assets/images/textanalysis.png'},
//   {'component':'app-theme-identification','title':'Theme Identification','description':'Option to generate part of speech tagging that will enable user in quickly understanding the various part of speech components that exists in long data which in turn helps in quick decision making','imageSrc':'../../../assets/images/textanalysis.png'},
//   {'component':'app-word-cloud','title':'Word Cloud','description':'Option to generate part of speech tagging that will enable user in quickly understanding the various part of speech components that exists in long data which in turn helps in quick decision making','imageSrc':'../../../assets/images/textanalysis.png'},
//   {'component':'app-sentiment-analysis','title':'Sentiment Analysis','description':'Option to generate part of speech tagging that will enable user in quickly understanding the various part of speech components that exists in long data which in turn helps in quick decision making','imageSrc':'../../../assets/images/textanalysis.png'}
// ]
  public dataSource:any;
  activeClass = true;
  constructor(
    private api:DataService,      
   public fb: UntypedFormBuilder,
   private app: AppComponent,
   private landing:JobProfileLandingComponent
   

) { this.storage = sessionStorage;
   this.form = this.fb.group({
 job_title: ['', Validators.required],
 job_family:['',Validators.required],
 job_profile_match_file: [null,Validators.required],
 
 //,requiredFileType('csv')],
 FileSearch:[false],
 
 
})}

  ngOnInit(): void {
    this.form = this.fb.group({
      job_family_group: [], 
      job_title: '',
      job_family : ''
      // Initialize the form control without a default value
    });
    
    if(this.jobProfilePage=="survey")
    {
    this.imageUrl = "../../../assets/images/Job-profile-main.jpg";
    this.headertext = "Machine Learning and AI enabled algorithm to match jobs to market surveys"
    this.showResults=false;
    this.displayedColumns=[];
    this.dataSource =[]
    this.aqchecked=false;
    }
    else
    {
    this.imageUrl = "../../../assets/images/aq-jobprofile-inside.jpg";
    this.downloadhref = "assets/Templates/jobprofilematching-aq.xlsx"
    this.headertext = "Machine Learning and AI enabled algorithm to match new jobs to existing jobs."
    this.displayedColumns=[];
    this.dataSource =[]
    this.showResults =false;
    this.aqchecked=true
    let auth_token=this.storage["msal.idtoken"]
    this.loadmsg=false;
    this.ShowLoader='block';
    this.pageload=true;
    this.submitclicked=false;
    this.api.getdropdownlist(auth_token).subscribe((result:any) => {
    this.jobfamilygroup = result.output
   // this.checkedarray = result.output  
   
      // for(let i =0;i<this.jobfamilygroup.length;i++)
      //  {
      
      //   this.selectedItems.push(this.jobfamilygroup[i])
      //  }
        console.log(this.selectedItems)
       
     
      this.ShowLoader='none';
      
      this.loadmsg=true;
      this.form.get('job_family_group')?.setValue(
        this.checkedarray
      );

      // Logging the selected value
      console.log(this.form.get('job_family_group')?.value)
    })
  
    console.log('ashish')
  }
    
   // this.headertext = "Machine Learning and AI enabled algorithm to match jobs to market surveys"
    this.check_jobdesc =false;
    this.check_jobtitle=false;

   
    
    

}



  onItemSelect(item: any) {
    this.checkedarray.push(item)
   
}
onItemDeSelect(item: any) {
  let index = this.checkedarray.indexOf(item);
  this.checkedarray.splice(index, 1);
    // console.log('onItemDeSelect', item);
}
onSelectAll(items: any) {
  this.checkedarray.splice(0)
    this.checkedarray = items
    
  
}
onUnSelectAll() {
  // console.log('onUnSelectAll fires');
  this.checkedarray.splice(0)
  

}

  onSelectChange(event: any) {
    // event.target.value contains the selected value
    const selectedValue = event.target.value;
  this.seljobfamilygroup =  selectedValue;
    
    // You can use the selectedValue as needed
  }
  onToggleChange(checked: boolean) {
    // this.aqchecked = checked
    // if(!checked)
    // {
    // this.imageUrl = "../../../assets/images/Job-profile-main.jpg";
    // this.headertext = "Machine Learning and AI enabled algorithm to match jobs to market surveys"
    // this.showResults=false;
    // }
    // else
    // {
    // this.imageUrl = "../../../assets/images/aq-jobprofile-inside.jpg";
    // this.headertext = "Machine Learning and AI enabled algorithm to match new jobs to existing jobs."
    // this.displayedColumns=[];
    // this.dataSource =[]
    // this.showResults =false;
    // }
  }

  // Get Uniqu values from columns to build filter
  getFilterObject(fullObj: any[], key: string | number) {
    const uniqChk:any = [];
    fullObj.filter((obj) => {
      if (!uniqChk.includes(obj[key])) {
        uniqChk.push(obj[key]);
      }
      return obj;
    });
    return uniqChk;
  }

   linesNumber(file: any): number {
    try {
      var nLines = 0;
      for( var i = 0, n = file.length;  i < n;  ++i ) {
          if( file[i] === '\n' ) {
              ++nLines;
          }
      }
      console.log(nLines);
      return nLines;
    } catch (err) {
      return 0;
    }
  }

  resetFile(event:any){
    this.form.patchValue( {'job_profile_match_file':null} );
  }

  getHeaderArray(csvRecordsArr: any) {  
    let headers = (<string>csvRecordsArr[0]).split(',');  
    let headerArray = [];  
    for (let j = 0; j < headers.length; j++) {  
      headerArray.push(headers[j]);  
    }  
    return headerArray;  
  }

    single:boolean=true;
    multiple:boolean=false;
   
    
    singleprofile(){
        this.single=true;
        this.multiple=false;
        this.activeClass =!this.activeClass
  
       
        
    }

    multipleprofile(){
        this.single=false;
        this.multiple=true;
        this.activeClass =!this.activeClass
    }

   
  CSVToArray( strData:any, strDelimiter:string ){
		// Check to see if the delimiter is defined. If not,
		// then default to comma.
		strDelimiter = (strDelimiter || ",");

		// Create a regular expression to parse the CSV values.
		var objPattern = new RegExp(
			(
				// Delimiters.
				"(\\" + strDelimiter + "|\\r?\\n|\\r|^)" +

				// Quoted fields.
				"(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +

				// Standard fields.
				"([^\"\\" + strDelimiter + "\\r\\n]*))"
			),
			"gi"
			);


		// Create an array to hold our data. Give the array
		// a default empty first row.
		var arrData:any = [[]];

		// Create an array to hold our individual pattern
		// matching groups.
		var arrMatches = null;


		// Keep looping over the regular expression matches
		// until we can no longer find a match.
		while (arrMatches = objPattern.exec( strData )){

			// Get the delimiter that was found.
			var strMatchedDelimiter = arrMatches[ 1 ];

			// Check to see if the given delimiter has a length
			// (is not the start of string) and if it matches
			// field delimiter. If id does not, then we know
			// that this delimiter is a row delimiter.
			if (
				strMatchedDelimiter.length &&
				(strMatchedDelimiter != strDelimiter)
				){

				// Since we have reached a new row of data,
				// add an empty row to our data array.
				arrData.push( [] );

			}


			// Now that we have our delimiter out of the way,
			// let's check to see which kind of value we
			// captured (quoted or unquoted).
			if (arrMatches[ 2 ]){

				// We found a quoted value. When we capture
				// this value, unescape any double quotes.
				var strMatchedValue = arrMatches[ 2 ].replace(
					new RegExp( "\"\"", "g" ),
					"\""
					);

			} else {

				// We found a non-quoted value.
				var strMatchedValue = arrMatches[ 3 ];

			}


			// Now that we have our value string, let's add
			// it to the data array.
			arrData[ arrData.length - 1 ].push( strMatchedValue );
		}

		// Return the parsed data.
		return( arrData );
	}

  uploadFile(event:any) {
    //debugger;
    //this.form.setValue({job_title:this.form.get('job_title')?.value,job_family:this.form.get('job_family')?.value,job_profile_match_file: this.form.get('job_title')?.value,FileSearch:[true]});
    // if(this.form.get('job_profile_match_file')?.value!==null){
    //   this.form.get('job_profile_match_file')?.reset();
    // }
    this.fileLimitexceeded=false;
    let extensionAllowed:any = {"xlsx":true};
    console.log(event.target.files,event.target.files[0].size);
    if (event.target.files[0].size / 1024 / 1024 > 2) {
      
      alert("File size should be less than 2MB")
      this.form.patchValue( {'job_profile_match_file':null} );
      return;
    }
    if (extensionAllowed) {
      var nam = event.target.files[0].name.split('.').pop();
      if (!extensionAllowed[nam]) {
        
        alert("Please upload " + Object.keys(extensionAllowed) + " file.")
        this.form.patchValue( {'job_profile_match_file':null} );
        return;
      }
    }
    //this.form.controls["job_profile_match_file"].setValue(event.target.files[0]);
    this.file = event.target.files[0];
    

    let fileReader = new FileReader();
    fileReader.readAsText(this.file);

    fileReader.onload = (e) => {
      let csvData=fileReader.result;
      console.log(csvData);
      let csvRecordsArray=this.CSVToArray(csvData,",");
      console.log(csvRecordsArray);
      // let csvRecordsArray = (<string>csvData).split(/\r\n|\n/);
      // console.log(csvRecordsArray);  
      // let headersRow = this.getHeaderArray(csvRecordsArray);  
      let lastRecord=csvRecordsArray[csvRecordsArray.length-1];
      if(lastRecord.length==1 && lastRecord[0]==''){
        csvRecordsArray.splice(csvRecordsArray.length-1,1);
      }
      console.log(csvRecordsArray.length);
      // if(csvRecordsArray.length>4){
      //   this.fileLimitexceeded=true;
      // }

    }
    

    
      // const file:File = (event.target as HTMLInputElement).files[0];
    
    // this.form.patchValue({
    //   job_profile_match_file: file
    // });
    
    // if(this.form.get('job_profile_match_file')){
    //   this.form.get('job_profile_match_file')?.updateValueAndValidity();
    // }
    
  }
  ShowDivcontent(e:any)
  {
    console.log('Calling')
    this.app.ShowDiv('JobProfileMatching');
  }
  
 

  new_showComponent(ncomp:any){
    this.app.ShowDiv(ncomp);
   
    
  }
  showpopup()
  {
    
  
  }
  showpopupAdmin()
  {
    
  }
  
  showpopupvideo()
  {
    
  }
 
  submitForm() {
    console.log('hi')
    
    
    
    console.log(this.checkedarray)

    var formData: any = new FormData();
    if(this.aqchecked==true)
    {
      this.pageload=false;
      this.submitclicked=true;
      let job_family_group_final = ""
      for (let i = 0; i < this.checkedarray.length; i++) {  
        job_family_group_final = job_family_group_final+ this.checkedarray[i] +'+'
      }
    job_family_group_final = job_family_group_final.substring(0,job_family_group_final.length-1)     
    console.log(job_family_group_final) 
    formData.append("job_family_group", job_family_group_final);

      
    }
    if(this.multiple){
       
        if(this.file==undefined){
          this.ShowLoader='none';
          this.showRefreshbtn=true;
          this.errorMsg='Something is not quite right in the form! Please rectify errors and try again!'
        return;
        }
        else{
          formData.append("job_profile_match_file", this.file);
        }

      }
      else{
      formData.append("job_title", this.form.get('job_title')?.value);
      formData.append("job_family", this.form.get('job_family')?.value);

      this.jobTitle=this.form.get('job_title')?.value;
      this.jobDescription=this.form.get('job_family')?.value;
      if(this.jobTitle.trim()==''){
        this.ShowLoader='none';
         // this.showRefreshbtn=true;
        //  this.errorMsg='Please provide Job Title/Job Description'
          this.check_jobtitle=true;
        return;
      }
      else
      {
        this.check_jobtitle=false
      }
      if(this.jobDescription.trim()==''){
        this.ShowLoader='none';
         // this.showRefreshbtn=true;
        //  this.errorMsg='Please provide Job Title/Job Description'
          this.check_jobdesc=true;
        return;
      }
      else{
        this.check_jobdesc=false;
      }
      
      
      }
      this.check_jobdesc = false;
      this.check_jobtitle=false;
      const now = new Date();
    let sdate = now.toISOString()
    this.todaydate ='jobprofile_'+sdate.substring(0,10)
    this.ShowLoader='block';
    this.ELEMENT_DATA=[];
    this.errorMsg='';
    this.showResults=false;
    this.showRefreshbtn=false;
    let auth_token=this.storage["msal.idtoken"]
    
    this.api.submitJobProfileData(auth_token,formData,this.aqchecked).subscribe((result:any) => {
  
    console.log('inside')

      if(result.MatchList.includes("KeyError"))
      {
        this.showRefreshbtn=true;
        this.errorMsg='Please enter valid Job Title and Job Description'
        this.ShowLoader='none';
        return;
      }
      
     
      
      this.showResults=true;
      let jobFamilies:string[]=result.MatchList.map((item:any)=>item.jobFamily).filter((value:any, index:number, self:any) => self.indexOf(value) === index);
      this.filters=[];
      this.filters.push({
        name:'jobFamily',
        options:jobFamilies,
        defaultValue:jobFamilies[0]
      })



      //this.displayedColumns=Object.keys(this.ELEMENT_DATA[0]).filter((elem)=>elem!='jobFamily');
      //  this.uniqueJobFamilyList=result.MatchList.map((item: { jobFamily: any; },index: any)=>({'item_id':index,'item_text':item.jobFamily}))
      //  .filter((value: any, index: any, self: string | any[]) => self.indexOf(value) === index);
      //  this.uniqueJobFamilyList=response.MatchList.map((item: { jobFamily: any; }) => item.jobFamily)
      //  .filter((value: any, index: any, self: string | any[]) => self.indexOf(value) === index);
      // this.selectedJobTitle=[];
      
    
      
 
 if(this.aqchecked)
 {
  for(let i=0;i<result.MatchList.length;i++)
  {
    let jd="Job Family Summary"
    let obj = result.MatchList[i];
 
     obj["Job Family Summary"] = obj["Job Family Summary"].replaceAll('<95>','•')
     obj["Job Family Summary"] = obj["Job Family Summary"].replaceAll('<92>','`')
     obj["Job Family Summary"] = obj["Job Family Summary"].replaceAll('<93>','“')
     obj["Job Family Summary"] = obj["Job Family Summary"].replaceAll('<94>','”')
 
  }
 }
 else
 {
  for(let i=0;i<result.MatchList.length;i++)
 {
   let jd="Job Description"
   let obj = result.MatchList[i];

    obj["Job Description"] = obj["Job Description"].replaceAll('<95>','•')
    obj["Job Description"] = obj["Job Description"].replaceAll('<92>','`')
    obj["Job Description"] = obj["Job Description"].replaceAll('<93>','“')
    obj["Job Description"] = obj["Job Description"].replaceAll('<94>','”')

 }
 }

 this.ELEMENT_DATA=result.MatchList;
      this.dataSource= new MatTableDataSource(this.ELEMENT_DATA);
      console.log(this.dataSource)
      this.displayedColumns=Object.keys(this.ELEMENT_DATA[0]);
      //we are arranging sequence here for Aqu
      if(this.aqchecked)
      {
        this.displayedColumns= ['jobFamily', 'JFG Code','Job Family Group Name','Job Family Group Summary','Job Family Code','Job Family Name','Job Family Summary','Progression_Model','Restrictions_by_JP','Comments','Input job Family Description']
        //this.displayedColumns= ['jobFamily', 'Job Family Summary', 'Job Family Name',  'JFG Code','Job Family Code' , 'Job Family Group Summary', 'Job Family Group Name','Comments','Restrictions_by_JP','Input job Family Description']
      }
      console.log(Object.keys(this.ELEMENT_DATA[0]))
      this.dataSource.filterPredicate=function(record:JobProfile,filter:any){
        var map = new Map(JSON.parse(filter));
        let isMatch = false;
        for (let [key, value] of map) {
          isMatch = record[key as keyof JobProfile] == value;
          if (!isMatch) return false;
        }
        return isMatch;
      };
      this.applyInitialFilter(this.filters[0].name,this.filters[0].defaultValue);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.ShowLoader='none';
     
    },
    (error) => {
      console.log(error);
      this.ShowLoader='none';
      if(error.statusText!=='OK' || error.status!==200){
        this.showRefreshbtn=true;
        this.errorMsg='Something went wrong! Please try again!'
      }

    })
    
    
  }
  
  public export() {
    const now = new Date();
    let sdate = now.toISOString()
    const workBook = XLSX.utils.book_new(); // create a new blank book
    if(this.aqchecked)
    {
      this.todaydate ='jobprofile_new_jobs_to_existing_jobs_'+sdate.substring(0,10)
      const workSheet = XLSX.utils.json_to_sheet(this.ELEMENT_DATA,{header:['jobFamily', 'Input job Family Description','Input JFG Values', 'JFG Code','Job Family Group Name','Job Family Group Summary','Job Family Code','Job Family Name','Job Family Summary','Progression_Model','Restrictions_by_JP','Comments']});
      
      workSheet.A1.v= "Input Job family Name"
      workSheet.B1.v= "Input Job Family Description"
      workSheet.C1.v= "Input JFG Values"
      workSheet.D1.v= "JFG Code"
      workSheet.E1.v= "Job Family Group Name"
      workSheet.F1.v= "Job Family Group Summary"
      workSheet.G1.v= "Job Family Code" 
      workSheet.H1.v= "Job Family Name"
      workSheet.I1.v= "Job Family Summary"
      workSheet.J1.v= "Progression_Model"
      workSheet.K1.v= "Restrictions by JP"
      workSheet.L1.v= "Comments"
      
      
      XLSX.utils.book_append_sheet(workBook, workSheet, 'data'); // add the worksheet to the book
      XLSX.writeFile(workBook, this.todaydate+'.xlsx'); // initiate a file download in browser
    }
  
    else
    {
    
    this.todaydate ='jobprofile_jobs_to_market_surveys_'+sdate.substring(0,10)
    const workSheet = XLSX.utils.json_to_sheet(this.ELEMENT_DATA,{header:['jobFamily','Input job Family Description' ,'Survey Vendor','Survey Name','Survey Job Code','Job Title','Job Description']});
    workSheet.A1.v= "Job family Name"
    workSheet.B1.v= "Job Family Description"
    workSheet.C1.v= "Survey vendor"
    workSheet.D1.v= "Survey name"
    workSheet.E1.v= "Survey Job/Family Code"
    workSheet.F1.v= "Survey Job Family Name"
    workSheet.G1.v= "Survey Job/Family description"
    XLSX.utils.book_append_sheet(workBook, workSheet, 'data'); // add the worksheet to the book
    XLSX.writeFile(workBook, this.todaydate+'.xlsx'); // initiate a file download in browser
    }

   
    
  }
   // Called on Filter change
  //  filterChange(filter: { columnProp: string | number; },event:any ) {
  //   //let filterValues = {}
  //   debugger;
  //   this.filterValues[filter.columnProp] = event.target.value;
  //   this.dataSource.filter = JSON.stringify(this.filterValues)
  // }
  applyFilter(ob:MatSelectChange,filter:any){
    this.filterDictionary.set(filter.name,ob.value);
    var jsonString = JSON.stringify(
      Array.from(this.filterDictionary.entries())
    );

    this.dataSource.filter = jsonString;
  }

  applyInitialFilter(attribute:string,value:string){
    this.filterDictionary.set(attribute,value);
    var jsonString = JSON.stringify(
      Array.from(this.filterDictionary.entries())
    );

    this.dataSource.filter = jsonString;
  }

 goBack(){
    this.app.ShowDiv('Home');
  } 

  // Custom filter method fot Angular Material Datatable
  createFilter() {
    let filterFunction = function (data: any, filter: string): boolean {
      let searchTerms = JSON.parse(filter);
      let isFilterSet = false;
      for (const col in searchTerms) {
        if (searchTerms[col].toString() !== '') {
          isFilterSet = true;
        } else {
          delete searchTerms[col];
        }
      }

      //console.log(searchTerms);

      let nameSearch = () => {
        let found = false;
        if (isFilterSet) {
          for (const col in searchTerms) {
            searchTerms[col].trim().toLowerCase().split(' ').forEach((word:any) => {
              if (data[col].toString().toLowerCase().indexOf(word) != -1 && isFilterSet) {
                found = true
              }
            });
          }
          return found
        } else {
          return true;
        }
      }
      return nameSearch()
    }
    return filterFunction
  }

//Reset table filters
// resetFilters() {
//   this.filterValues = {}
//   this.filterSelectObj.forEach((value: { modelValue: undefined; }, key: any) => {
//     value.modelValue = undefined;
//   })
//   this.dataSource.filter = "";
// }

  //add selected filter
// onItemSelect(item: any) {
//   console.log(item.item_text);
//   //this.dataSource.filter(item=>item.job_family==item.text);
// }

//add all selected filter
// onSelectAll(items: any) {

  
// }
// onItemDeSelect(item:any){

// }
// onDeSelectAll(items:any){

// }


refreshForm(){
  this.form.reset();
//   this.form.setValue({job_title: '',
//   job_family:'',
//   job_profile_match_file: null,
//   FileSearch:[false]
// });
this.showRefreshbtn=false;
}
filedownload()
{
  console.log(typeof this.mainresult)
  
  
  this.downloadFile(this.ELEMENT_DATA,this.todaydate)
}


downloadFile(data:any, filename:any) {
  let csvData = this.ConvertToCSV(data,  ['jobFamily', 'Survey Vendor' , 'Survey Name', 'Survey Job Code', 'Job Title', 'Job Description', 'Input job Family Descrption']);
  
  let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
  let dwldLink = document.createElement("a");
  let url = URL.createObjectURL(blob);
  let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
  if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
  }
  dwldLink.setAttribute("href", url);
  dwldLink.setAttribute("download", filename + ".csv");
  dwldLink.style.visibility = "hidden";
  document.body.appendChild(dwldLink);
  dwldLink.click();
  document.body.removeChild(dwldLink);
}

ConvertToCSV(objArray:any, headerList:any) {
  let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
   let str = '';
   let row = 'S.No,';

   for (let index in headerList) {
       row += headerList[index] + ',';
   }
   row = row.slice(0, -1);
   str += row + '\r\n';
   for (let i = 0; i < array.length; i++) {
       let line = (i+1)+'';
       for (let index in headerList) {
          let head = headerList[index];

           line += ',' + array[i][head];
       }
       str += line + '\r\n';
   }
   return str;
}
}

